<template>
  <WsUpdate
    ref="wsUpdate"
    pageTitle="鑑別人員與法規內容"
    :label="label"
    :fields="fields"
    :id="$route.params.id"
    :modelName="modelName"
    :multiUrl="$_getMultiUrl"
    :primary="pageSetting.primary"
    :titleKey="'last_version.name'"
    :customBreads="breadcrumbsItems"
    :secondary="pageSetting.secondary"
    :modelVersionName="modelVersionName"
    :customParentData="$_getCustomParentData"
    :customUpdateAction="$_customUpdateAction"
    :customBtns="customBtns"
    @input="$_getModelData($event)"
    @input-updateData="$_getUpdateData($event)"
    @cancel="$_onCancel"
    @submit="$_onSubmit"
  />
</template>

<script>
import model from '@/models/act_cnt_update';
import idtfModel from '@/models/act_idtf_assignment';

export default {
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.app.needSave) {
      const ans = window.confirm('確認捨棄目前編輯內容嗎？');
      if (ans) {
        this.$store.dispatch('app/stopNeedSave');
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  data(){
    return {
      modelData: {},
      modelName: 'act_idtf_assignment',
      modelVersionName: model.versionModelName,
      label: model.label,
      fields: idtfModel.fields,
      breadcrumbsItems: [
        {
          text: model.label,
          to: '/act_cnt_update',
          disabled: false,
        },
        {
          text: '',
          to: `/act_cnt_update/${this.$route.params.id}`,
          disabled: false,
        },
        {
          text: '編輯當前版本題目',
          disabled: true,
        },
      ],
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '法規內容',
                fields: ['last_version'],
                hideLabelFields: ['last_version'],
              },
            ],
          }
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '鑑別人員設定',
                fields: [
                  'overall_owners',
                  'km_owners',
                  'km_backups',
                  'km_reviewers',
                  'idtf_owners',
                  'idtf_backups',
                  'idtf_reviewers',
                ],
              },
            ],
          },
        ],
      },
      updateData: {},
      customBtns: {
        isHideRegularBtns: true,
        btns: [
          {
            title: '取消',
            color: 'textSecondary',
            outlined: true,
            emit: 'cancel'
          },
          {
            title: '送出',
            outlined: false,
            emit: 'submit',
            isValidateForm: true,
          },
        ],
      }
    }
  },
  methods:{
    $_getMultiUrl(modelData) {
      if (!modelData) return [];
      return [
        `/act/${modelData.act_version.act.id}`
      ];
    },
    $_customUpdateAction(updateData,modelData) {
      updateData['act_version'] = modelData.last_version.id;
      return updateData;
    },
    async $_getModelData($event) {
      if (Object.keys(this.modelData).length === 0) this.modelData = $event;
      if ($event.name) this.$_getCustomBreads($event);
    },
    $_getCustomBreads($event) {
      this.$set(this.breadcrumbsItems[1], 'text', $event.name);
    },
    $_getCustomParentData() {
      return { is_active: 1 };
    },
    async $_onSubmit() {
      const wsUpdate = this.$refs.wsUpdate;
      wsUpdate.submitLoading = true;
      let postData = JSON.parse(JSON.stringify(this.updateData));
      postData = this.$_customUpdateAction(postData, this.modelData);
      try {
        const res = await this.$axios.patch(
          `/${this.modelName}/${this.$route.params.id}`,
          postData
        );
        await this.$axios.patch(
          `/act_version/${this.modelData.last_version.id}`,
          postData.last_version
        );
        this.$store.dispatch('app/stopNeedSave');
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push(`/${this.modelName}/${res.data.data.id}`);
        }
      } catch (err) {
        console.log('submit error: ', err);
      } finally {
        this.$store.dispatch('app/stopNeedSave');
        wsUpdate.submitLoading = false;
      }
    },
    $_getUpdateData($event) {
      this.updateData = $event;
    },
    $_onCancel() {
      this.$router.go(-1);
    },
  },
};
</script>